'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidList = function IoAndroidList(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.9 5c1.7 0 3.1 1.4 3.1 3.1v23.8c0 1.7-1.4 3.1-3.1 3.1h-23.8c-1.7 0-3.1-1.4-3.1-3.1v-23.8c0-1.7 1.4-3.1 3.1-3.1h23.8z m-8.1 23.8v-3.8h-12.5v3.8h12.5z m5-6.9v-3.8h-17.5v3.8h17.5z m0-6.9v-3.7h-17.5v3.7h17.5z' })
        )
    );
};

exports.default = IoAndroidList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-list.js
// module id = 1901
// module chunks = 0